export const Klarna = () => (
  <svg height="20" width="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="#FFA8CD" d="M0 0h32v32H0z"></path>
    <path
      fill="#0B051D"
      d="M23.665 6h-4.342c0 3.571-2.185 6.771-5.506 9.057l-1.305.914V6H8v20h4.512v-9.914L19.975 26h5.506l-7.18-9.486c3.264-2.371 5.392-6.057 5.364-10.514Z"
    ></path>
  </svg >
)

export const LinkIcon = () => (
  <svg height="20" width="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="#00D66F" d="M0 0h32v32H0z"></path>
    <path
      fill="#011E0F"
      d="M15.144 6H10c1 4.18 3.923 7.753 7.58 10C13.917 18.246 11 21.82 10 26h5.144c1.275-3.867 4.805-7.227 9.142-7.914v-4.18c-4.344-.68-7.874-4.04-9.142-7.906Z"
    ></path>
  </svg>

)
export const CashApp = () => (
  <svg height="20" width="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="#00D64F" d="M0 0h32v32H0z"></path>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.892 10.264c1.782 0 3.49.693 4.607 1.643.282.24.705.24.97-.018l1.328-1.293a.646.646 0 0 0-.032-.968 10.625 10.625 0 0 0-3.56-1.92l.416-1.903C20.71 5.39 20.38 5 19.94 5h-2.567a.69.69 0 0 0-.68.528l-.376 1.693c-3.412.163-6.303 1.796-6.303 5.147 0 2.9 2.392 4.144 4.917 5.004 2.393.86 3.655 1.18 3.655 2.391 0 1.243-1.262 1.976-3.123 1.976-1.697 0-3.475-.537-4.854-1.841a.713.713 0 0 0-.974-.002l-1.427 1.35a.652.652 0 0 0 .004.96c1.113 1.036 2.522 1.786 4.13 2.206l-.391 1.763c-.092.413.234.803.676.806l2.57.019a.689.689 0 0 0 .686-.53l.371-1.695c4.085-.242 6.586-2.372 6.586-5.49 0-2.868-2.492-4.08-5.516-5.068-1.728-.606-3.224-1.02-3.224-2.263 0-1.21 1.397-1.69 2.792-1.69Z"
      fill="#fff"
    ></path>
  </svg>
)

export const Amazon = () => (
  <svg height="20" width="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="#333E48" d="M0 0h32v32H0z"></path>
    <path
      fill="#F90"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.597 21.086c-2.737 2.02-6.705 3.094-10.122 3.094-4.789 0-9.101-1.77-12.364-4.717-.256-.232-.028-.547.28-.368 3.52 2.049 7.875 3.283 12.372 3.283 3.033 0 6.368-.63 9.436-1.932.463-.196.851.305.398.64Z"
    ></path>
    <path
      fill="#F90"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.736 19.785c-.35-.448-2.314-.212-3.196-.106-.267.032-.309-.202-.068-.37 1.567-1.101 4.134-.784 4.432-.415.3.371-.079 2.946-1.546 4.174-.227.188-.442.088-.341-.161.33-.826 1.07-2.673.72-3.122Z"
    ></path>
    <path
      fill="#fff"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.538 19.277v-.467c0-.133.065-.225.204-.216.259.036.624.073.884.02.34-.071.583-.312.727-.641.202-.464.337-.838.421-1.083L20.2 10.51c-.043-.109-.056-.31.16-.31h.9c.172 0 .242.11.28.216l1.867 5.182 1.783-5.182c.036-.106.11-.216.28-.216h.848c.215 0 .203.201.16.31l-2.554 6.579c-.33.876-.771 2.27-1.763 2.513-.497.13-1.125.082-1.493-.072-.093-.047-.129-.171-.129-.253Zm-1.201-2.669a.217.217 0 0 1-.216.216h-.635a.247.247 0 0 1-.248-.216l-.064-.432c-.292.247-.65.464-1.038.615-.747.29-1.608.338-2.337-.11-.528-.324-.808-.957-.808-1.61 0-.505.156-1.006.5-1.37.461-.497 1.129-.74 1.935-.74.487 0 1.184.057 1.691.223v-.87c0-.884-.372-1.267-1.354-1.267-.75 0-1.324.113-2.123.362-.128.004-.202-.093-.202-.212v-.496c0-.119.101-.234.211-.269.57-.249 1.379-.404 2.238-.432 1.12 0 2.45.252 2.45 1.975v4.633Zm-1.22-1.27v-1.311c-.426-.117-1.131-.165-1.404-.165-.431 0-.903.102-1.15.367-.184.195-.267.474-.267.744 0 .35.12.7.403.872.327.223.836.196 1.314.06.459-.13.89-.36 1.104-.566Zm-8.14-4.271c1.408 0 1.792 1.107 1.792 2.376.008.854-.15 1.617-.592 2.053-.332.327-.702.416-1.259.416-.496 0-1.148-.259-1.635-.619v-3.626c.507-.39 1.154-.6 1.694-.6Zm-1.91 8.437h-.85A.217.217 0 0 1 7 19.288v-8.86c0-.119.097-.216.216-.216h.651c.137 0 .23.099.248.216l.068.464c.61-.541 1.395-.888 2.143-.888 2.094 0 2.783 1.726 2.783 3.52 0 1.92-1.054 3.463-2.835 3.463-.75 0-1.452-.277-1.991-.758v3.06a.217.217 0 0 1-.216.215Z"
    ></path>
  </svg>
)

